import { SyntheticEvent } from 'react';

export const composeEventHandlers = <T extends SyntheticEvent>(
  firstEventHandler: (event: T) => void,
  secondEventHandler?: (event: T) => void
) => {
  return (event: T): void => {
    if (secondEventHandler) {
      secondEventHandler(event);
    }
    firstEventHandler(event);
  };
};

export default composeEventHandlers;
